<template>
<v-list-tile
  v-if='showDeleted || form.status !== "DELETED"'
  @click='$emit("selected", form)'
  :class="getSelectedClasses"
  :key='form.id' >
  <v-list-tile-avatar >
    <v-img :src="jotformIcon" />
  </v-list-tile-avatar>
  <v-list-tile-content>
    <v-list-tile-title v-text='form.title' />
    <v-list-tile-sub-title>
      <v-chip v-if="form.status && form.status === 'DISABLED'" dark class='v-chip--x-small ml-0' :class="statusclasses" >
        {{form.status}}
      </v-chip>
      <v-chip dark
        v-if='form.linked_form' color='success' class='v-chip--x-small' >
        Linked
      </v-chip>
      <v-chip outline color="info" v-if="withNotifications" class='v-chip--x-small' >
        <v-icon small left >notifications_active</v-icon> Notifcation
      </v-chip>
    </v-list-tile-sub-title>
    <v-list-tile-sub-title v-if="form.spaces" >
      Installed in: <space-faces :space-ids="form.spaces" />
    </v-list-tile-sub-title>
  </v-list-tile-content>
  <template v-if="!readonly" >
    <template v-if='form.linked_form' >
      <v-list-tile-action >
        <v-btn icon small target='_blank' >
          <v-icon small>chevron_right</v-icon>
        </v-btn>
      </v-list-tile-action>
    </template>
    <v-list-tile-action v-else >
      <v-btn outline small
        @click.stop='$emit("link", form)' >
        <!-- <v-icon small class='mr-1' >link</v-icon> -->
        Link</v-btn>
    </v-list-tile-action>
  </template>
</v-list-tile>
</template>
<script>
import SpaceFaces from '@/components/lists/SpaceFaces.vue'
export default {
  name: 'FormListItem',
  components: {SpaceFaces},
  props: {
    item: { type: Object, required: true },
    showDeleted: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  },
  computed: {
    form () { return this.item },
    getSelectedClasses () {
      if (this.selectedForm && this.selectedForm.id) {
        if (this.form.id === this.selectedForm.id) { return ['blue', 'lighten-5'] }
      }
    },
    jotformIcon () {
      // let url = 'https://ik.imagekit.io/appointmentguru/partners/jotform/jotform-icon-white-560x560.png'
      let url = 'https://ik.imagekit.io/appointmentguru/partners/jotform/jotform-icon-dark-800x800.png'
      return this.imageKitUrl(url, 'n-avatar_md')
    },
    statusclasses () {
      if (this.form.status === 'DELETED') { return 'error' }
      if (this.form.status === 'ENABLED') { return 'success' }
    },
    withNotifications () {
      return this.getObjectPath(this.form, 'linked_form.include_on_appointment_page', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormListItem.vue?36738991